import { createDragDropManager } from 'dnd-core'
import { MultiBackend } from 'react-dnd-multi-backend'
import { HTML5toTouch } from 'rdndmb-html5-to-touch'

// One manager for the life of the page. react-dnd drops its own manager when the
// last DndProvider unmounts, and AuthProvider remounts the whole App on a session
// flip, so a provider-built manager made a second MultiBackend while the first was
// still set up and threw "Cannot have two MultiBackends at the same time".
export const dndManager = createDragDropManager(MultiBackend, undefined, HTML5toTouch)
